import { UiMoleculeIcon } from '../shared/shared.enum';

export enum UiNavigationExitType {
  NONE = 'none',
  BACK = 'back',
  CLOSE = 'close',
}
